'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Activeable = require('../decorators/Activeable');

var _Activeable2 = _interopRequireDefault(_Activeable);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../core/Functions');

var _UICheckbox = require('../input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UIRadioInput = require('../input/UIRadioInput');

var _UIRadioInput2 = _interopRequireDefault(_UIRadioInput);

var _SelectableBoxTypes = require('../constants/SelectableBoxTypes');

var _SelectableBoxTypes2 = _interopRequireDefault(_SelectableBoxTypes);

var _underscore = require('../utils/underscore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getRole = function getRole(type) {
  if (type === _SelectableBoxTypes2.default.radio) return 'radio';
  return 'checkbox';
};

var UISelectableBox = _react2.default.createClass({
  displayName: 'UISelectableBox',

  propTypes: {
    active: _react.PropTypes.bool,
    'aria-checked': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    flush: _react.PropTypes.bool,
    height: _react.PropTypes.number,
    hovered: _react.PropTypes.bool,
    innerClassName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onClick: _react.PropTypes.func,
    onSelectedChange: _react.PropTypes.func,
    padded: _react.PropTypes.bool,
    selected: _react.PropTypes.bool,
    selectionMarkLocation: _react.PropTypes.oneOf(['left', 'top-right']),
    tabIndex: _react.PropTypes.number,
    type: _react.PropTypes.oneOf(Object.keys(_SelectableBoxTypes2.default)),
    width: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      padded: true,
      selected: false,
      type: _SelectableBoxTypes2.default.default
    };
  },
  handleClick: function handleClick(evt) {
    var _props = this.props,
        type = _props.type,
        disabled = _props.disabled;

    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }
    if (type !== _SelectableBoxTypes2.default.radio) {
      this.props.onSelectedChange((0, _SyntheticEvent2.default)(!this.props.selected));
    }
    (0, _Functions.callIfPossible)(this.props.onClick);
  },
  handleKeyPress: function handleKeyPress(evt) {
    if (evt.target.type === 'checkbox') return;
    var key = evt.key;
    // treat enter or space key like a click event

    if (key === 'Enter' || key === ' ') {
      evt.preventDefault();
      this.handleClick();
    }
  },
  getClassName: function getClassName(_ref) {
    var active = _ref.active,
        block = _ref.block,
        className = _ref.className,
        disabled = _ref.disabled,
        flush = _ref.flush,
        hovered = _ref.hovered,
        padded = _ref.padded,
        selected = _ref.selected;

    return (0, _reactUtils.classNames)('uiButton', 'private-button', 'private-selectable-box', {
      'private-button--active': active,
      'private-selectable-box--selected': selected,
      'private-button--block': block,
      'disabled private-button--disabled': disabled,
      'private-selectable-box--hovered': hovered,
      'private-selectable-box--padded': padded,
      'private-selectable-box--flush': flush
    }, className);
  },
  getSelectionMarkClassName: function getSelectionMarkClassName(_ref2) {
    var selectionMarkLocation = _ref2.selectionMarkLocation;

    return (0, _reactUtils.classNames)('private-selectable-box__selection-mark', {
      'private-selectable-box__selection-mark--left': selectionMarkLocation === 'left',
      'private-selectable-box__selection-mark--top-right': selectionMarkLocation === 'top-right'
    });
  },
  renderCheckbox: function renderCheckbox(_ref3) {
    var idRef = _ref3.idRef,
        selected = _ref3.selected,
        disabled = _ref3.disabled,
        name = _ref3.name;

    return _react2.default.createElement(_UICheckbox2.default, {
      'aria-labelledby': idRef,
      checked: selected,
      disabled: disabled,
      innerPadding: 'none',
      name: name,
      onChange: this.handleClick,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    });
  },
  renderRadio: function renderRadio(_ref4) {
    var selected = _ref4.selected,
        disabled = _ref4.disabled,
        idRef = _ref4.idRef,
        name = _ref4.name;

    if (!name) {
      _devLogger2.default.warn({
        message: 'UISelectableBox: If type is set to radio you must provide a name',
        key: 'UISelectableBox: no name value'
      });
    }
    return _react2.default.createElement(_UIRadioInput2.default, {
      'aria-labelledby': idRef,
      checked: selected,
      disabled: disabled,
      name: name,
      onChange: this.handleClick,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    });
  },
  renderSelectionMark: function renderSelectionMark(_ref5) {
    var disabled = _ref5.disabled,
        idRef = _ref5.idRef,
        name = _ref5.name,
        selected = _ref5.selected,
        selectionMarkLocation = _ref5.selectionMarkLocation,
        type = _ref5.type;

    if (type !== _SelectableBoxTypes2.default.default) {
      var selectionMarkClassname = this.getSelectionMarkClassName({
        selectionMarkLocation: selectionMarkLocation
      });
      if (type === _SelectableBoxTypes2.default.checkbox) {
        return _react2.default.createElement(
          'div',
          { className: selectionMarkClassname },
          this.renderCheckbox({ idRef: idRef, selected: selected, disabled: disabled, name: name })
        );
      }
      if (type === _SelectableBoxTypes2.default.radio) {
        return _react2.default.createElement(
          'div',
          { className: selectionMarkClassname },
          this.renderRadio({ selected: selected, disabled: disabled, idRef: idRef, name: name })
        );
      }
    }

    return null;
  },
  renderInnerSelectableButton: function renderInnerSelectableButton(_ref6) {
    var children = _ref6.children,
        height = _ref6.height,
        idRef = _ref6.idRef,
        innerClassName = _ref6.innerClassName,
        width = _ref6.width;

    return _react2.default.createElement(
      'div',
      {
        className: (0, _reactUtils.classNames)('private-selectable-box__inner', innerClassName),
        id: idRef,
        style: { height: height, width: width }
      },
      children
    );
  },
  render: function render() {
    var _props2 = this.props,
        active = _props2.active,
        block = _props2.block,
        children = _props2.children,
        className = _props2.className,
        disabled = _props2.disabled,
        flush = _props2.flush,
        height = _props2.height,
        hovered = _props2.hovered,
        innerClassName = _props2.innerClassName,
        name = _props2.name,
        __onClick = _props2.onClick,
        __onSelectedChange = _props2.onSelectedChange,
        padded = _props2.padded,
        selected = _props2.selected,
        selectionMarkLocation = _props2.selectionMarkLocation,
        tabIndex = _props2.tabIndex,
        type = _props2.type,
        width = _props2.width,
        rest = _objectWithoutProperties(_props2, ['active', 'block', 'children', 'className', 'disabled', 'flush', 'height', 'hovered', 'innerClassName', 'name', 'onClick', 'onSelectedChange', 'padded', 'selected', 'selectionMarkLocation', 'tabIndex', 'type', 'width']);

    this._id = this._id || (0, _underscore.uniqueId)('bsb-');

    var computedClassName = this.getClassName({
      active: active,
      block: block,
      className: className,
      disabled: disabled,
      flush: flush,
      hovered: hovered,
      padded: padded,
      selected: selected
    });

    var renderedSelectionMark = this.renderSelectionMark({
      disabled: disabled,
      idRef: this._id,
      name: name,
      selected: selected,
      selectionMarkLocation: selectionMarkLocation,
      type: type
    });

    var renderedInnerSelectableButton = this.renderInnerSelectableButton({
      children: children,
      height: height,
      idRef: this._id,
      innerClassName: innerClassName,
      width: width
    });

    var tabbableByDefault = !disabled && type === _SelectableBoxTypes2.default.default;
    var defaultTabIndex = tabbableByDefault ? 0 : null;

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      _react2.default.createElement(
        'div',
        _extends({}, rest, {
          'aria-checked': selected,
          'aria-disabled': disabled,
          className: computedClassName,
          onClick: this.handleClick,
          onKeyPress: this.handleKeyPress,
          role: getRole(type),
          tabIndex: typeof tabIndex === 'number' ? tabIndex : defaultTabIndex
        }),
        renderedSelectionMark,
        renderedInnerSelectableButton
      )
    );
  }
});

exports.default = (0, _Activeable2.default)((0, _Hoverable2.default)((0, _Controllable2.default)(UISelectableBox, ['selected'])));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/button/UISelectableBox.js
// module id = 143
// module chunks = 0